import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@/app/styles/index.css';
import { bootstrap } from '@/app/boot/bootstrap';
import { App } from '@/app/App';
import { registerServiceWorker } from '@/shared/lib/push/pushClient';

registerServiceWorker();

const root = createRoot(document.getElementById('root')!);
bootstrap().finally(() => {
  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
